var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMirPayment = function SvgMirPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#40A548",
    fillRule: "evenodd",
    d: "M6.49 9.697h.046c.33-.006 1.135-.02 1.486 1.166q.372 1.258 1.186 4.123h.221q.874-3.02 1.2-4.123c.35-1.184 1.194-1.172 1.604-1.167l.072.001h2.874v8.95H12.25v-5.274h-.196l-1.633 5.275H8.217l-1.633-5.279h-.196v5.279h-2.93v-8.95zm12.895 0v5.279h.234l1.986-4.34a1.57 1.57 0 0 1 1.207-.939h2.835v8.95h-2.99V13.37h-.234l-1.947 4.34c-.386.86-1.247.939-1.247.939h-2.834v-8.95h2.99Zm13.42 6.284c1.45 0 2.76-.847 3.177-2.03h-9.156v4.697h2.843V15.98z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1291D0",
    d: "M32.942 9.697h-6.265c.149 1.993 1.863 3.699 3.637 3.699h5.866c.338-1.656-.827-3.699-3.238-3.699"
  })));
};
export default SvgMirPayment;